import { z } from 'zod'

export const qrCodesSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
})

export type QrCodesSearch = z.infer<typeof qrCodesSearchSchema>
